// Gallery coverflow Frame7 — Swiper 8 lấy global từ CDN libraryMainsite (không import).
// PC và MB là 2 instance riêng vì lib ẩn/hiện DOM theo MS__pc / MS__mb: mỗi bản có
// khung, mũi tên và dots riêng, dùng chung 1 instance sẽ đo sai kích thước slide.
window.addEventListener("load", function () {
	if (typeof Swiper === "undefined") return;

	function initGallery(rootSelector, dotsSelector, prevSelector, nextSelector, stretch) {
		var $root = document.querySelector(rootSelector);
		if (!$root) return;
		var dots = Array.prototype.slice.call(
			document.querySelectorAll(dotsSelector + " .dot"),
		);

		function syncDots(sw) {
			dots.forEach(function (d, i) {
				d.classList.toggle("is-active", i === sw.realIndex);
			});
		}

		// Design chỉ vẽ 5 slide (giữa + 2 mỗi bên) — slide xa hơn phải ẩn, nếu không
		// nó lòi ra hai mép trang vì .gallery để overflow visible.
		// PC design thấy 2 slide mỗi bên, MB chỉ 1 ⇒ ẩn phần còn lại cho khỏi lòi mép
		function hideFarSlides(sw) {
			var keep = window.matchMedia("(max-width: 768px)").matches ? 1 : 2;
			sw.slides.forEach(function (s) {
				s.style.visibility = Math.abs(s.progress) > keep + 0.5 ? "hidden" : "";
			});
		}

		var sw = new Swiper($root, {
			effect: "coverflow",
			centeredSlides: true,
			slidesPerView: "auto",
			loop: true,
			loopedSlides: 6,
			watchSlidesProgress: true,
			// depth 320 (perspective 1200) ⇒ slide kề scale 0.79, slide ngoài 0.66 — đúng như design.
			// stretch đo riêng cho từng bản vì độ hở 2 bên trong design KHÁC nhau:
			//   PC  : slide giữa 751..1169, slide kề 572..902  ⇒ stretch 136
			//   MB  : slide giữa 166..584,  slide kề 77..407   ⇒ stretch 250
			coverflowEffect: {
				rotate: 0,
				stretch: stretch,
				depth: 320,
				modifier: 1,
				slideShadows: false,
			},
			navigation: {
				prevEl: prevSelector,
				nextEl: nextSelector,
			},
			on: {
				init: function (sw) {
					syncDots(sw);
					hideFarSlides(sw);
				},
				slideChange: syncDots,
				setTranslate: hideFarSlides,
				setTransition: hideFarSlides,
			},
		});

		dots.forEach(function (d) {
			d.addEventListener("click", function () {
				sw.slideToLoop(parseInt(d.getAttribute("data-idx"), 10) || 0);
			});
		});
	}

	initGallery(
		"#Frame7 .gallery.MS__pc",
		"#Frame7 .gallery-dots.MS__pc",
		"#Frame7 .gallery-prev.MS__pc",
		"#Frame7 .gallery-next.MS__pc",
		136,
	);
	initGallery(
		"#Frame7 .gallery--mb",
		"#Frame7 .gallery-dots--mb",
		"#Frame7 .gallery-prev.MS__mb",
		"#Frame7 .gallery-next.MS__mb",
		250,
	);
});
